import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "helpTip",
  "use": "helpTip-usage",
  "viewBox": "0 0 65.58 65.58",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 65.58 65.58\" id=\"helpTip\"><title>资源 104</title><g id=\"helpTip_图层_2\" data-name=\"图层 2\"><g id=\"helpTip_图层_1-2\" data-name=\"图层 1\"><path d=\"M32.79,0A32.79,32.79,0,1,0,65.58,32.79,32.79,32.79,0,0,0,32.79,0Zm-.14,47.76A3.31,3.31,0,1,1,36,44.46,3.33,3.33,0,0,1,32.65,47.76Zm9-18.71a21.73,21.73,0,0,1-4.19,4.25,7.94,7.94,0,0,0-2.06,2.24,7.55,7.55,0,0,0-.37,3H30.26c0-.69,0-1.11,0-1.26A8.43,8.43,0,0,1,31,33.47a11.67,11.67,0,0,1,3.06-3.39,23.26,23.26,0,0,0,2.74-2.47,3.33,3.33,0,0,0,.69-2A3.44,3.44,0,0,0,36.28,23a4.77,4.77,0,0,0-3.3-1.1A5,5,0,0,0,29.63,23a7,7,0,0,0-1.85,3.49c-.17,1-4.87,1.4-4.81-.59a8.23,8.23,0,0,1,2.85-5.72,10.07,10.07,0,0,1,6.94-2.35,10.42,10.42,0,0,1,7.19,2.38,7.21,7.21,0,0,1,2.67,5.54A6.09,6.09,0,0,1,41.64,29.05Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/helpTip.svg
// module id = XJgd
// module chunks = 268